"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkTertiary = exports.buttonNote = exports.buttonWarningOutline = exports.buttonWarning = exports.buttonTertiary = exports.buttonSecondary = exports.buttonPrimaryOutline = exports.buttonPrimary = void 0;

var _base = require("./base");

var _swatches = require("../swatches");

var buttonPrimary = {
  background: _base.primary.brand,
  backgroundHover: _swatches.brand['700'],
  backgroundPressed: _swatches.brand['900'],
  backgroundDisabled: _swatches.brand['200'],
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _swatches.monochrome.white,
  textHover: _swatches.monochrome.white,
  textPressed: _swatches.monochrome.white,
  textDisabled: _swatches.monochrome.white
};
exports.buttonPrimary = buttonPrimary;
var buttonPrimaryOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _base.primary.brand,
  textHover: _swatches.brand['700'],
  textPressed: _swatches.brand['900'],
  textDisabled: _swatches.brand['200']
};
exports.buttonPrimaryOutline = buttonPrimaryOutline;
var buttonSecondary = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _base.primary.brand,
  textHover: _swatches.brand['700'],
  textPressed: _swatches.brand['900'],
  textDisabled: _swatches.brand['200']
};
exports.buttonSecondary = buttonSecondary;
var buttonTertiary = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.superLight,
  backgroundDisabled: _swatches.monochrome.white,
  border: _swatches.monochrome.medium,
  borderHover: _swatches.monochrome.black,
  borderPressed: _swatches.monochrome.black,
  borderDisabled: _swatches.monochrome.medium,
  text: _swatches.monochrome.dark,
  textHover: _swatches.monochrome.black,
  textPressed: _swatches.monochrome.black,
  textDisabled: _swatches.monochrome.mediumDark
};
exports.buttonTertiary = buttonTertiary;
var buttonWarning = {
  background: _base.primary.negative,
  backgroundHover: _swatches.negative['700'],
  backgroundPressed: _swatches.negative['900'],
  backgroundDisabled: _swatches.negative['200'],
  border: _base.primary.negative,
  borderHover: _swatches.negative['700'],
  borderPressed: _swatches.negative['900'],
  borderDisabled: _swatches.negative['200'],
  text: _swatches.monochrome.white,
  textHover: _swatches.monochrome.white,
  textPressed: _swatches.monochrome.white,
  textDisabled: _swatches.monochrome.white
};
exports.buttonWarning = buttonWarning;
var buttonWarningOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.negative,
  borderHover: _swatches.negative['700'],
  borderPressed: _swatches.negative['900'],
  borderDisabled: _swatches.negative['200'],
  text: _base.primary.negative,
  textHover: _swatches.negative['700'],
  textPressed: _swatches.negative['900'],
  textDisabled: _swatches.negative['200']
};
exports.buttonWarningOutline = buttonWarningOutline;
var buttonNote = {
  background: _base.primary.warning,
  backgroundHover: _swatches.warning['700'],
  backgroundPressed: _swatches.warning['900'],
  backgroundDisabled: _swatches.warning['200'],
  border: _base.primary.warning,
  borderHover: _swatches.warning['700'],
  borderPressed: _swatches.warning['900'],
  borderDisabled: _swatches.warning['200'],
  text: _swatches.monochrome.black,
  textHover: _swatches.monochrome.black,
  textPressed: _swatches.monochrome.black,
  textDisabled: "rgba(".concat(_swatches.monochrome.black_rgba, ", .5)")
};
exports.buttonNote = buttonNote;
var linkTertiary = {
  text: _swatches.monochrome.black
};
exports.linkTertiary = linkTertiary;
//# sourceMappingURL=button.js.map